import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo">
            <img src="/logo-white.svg" alt="Recvisit" className="footer-logo-img" />
            <p className="footer-tagline">Учет посещаемости на объектах</p>
            <p className="footer-disclaimer">
              Изображения устройств на сайте являются иллюстративными примерами и не являются рекомендацией к использованию
              конкретных моделей или производителей. Совместимость определяется минимальными системными требованиями.
            </p>
            <a className="footer-link footer-inline-link" href="/system-requirements">
              Системные требования →
            </a>
          </div>
          
          <div className="footer-contact">
            <h4 className="footer-title">Контакты</h4>
            <a href="mailto:info@recvi.ru" className="footer-link">
              info@recvi.ru
            </a>
            <a href="https://t.me/recvisitbot" target="_blank" rel="noopener noreferrer" className="footer-link">
              Тех. поддержка (Telegram)
            </a>
            <a href="/contacts" className="footer-link">
              Страница контактов
            </a>
          </div>

          <div className="footer-links">
            <h4 className="footer-title">Документы</h4>
            <ul className="footer-list">
              <li><a className="footer-link" href="/terms">Пользовательское соглашение</a></li>
              <li><a className="footer-link" href="/privacy">Политика конфиденциальности</a></li>
              <li><a className="footer-link" href="/offer">Публичная оферта</a></li>
              <li><a className="footer-link" href="/cookies">Cookies</a></li>
              <li><a className="footer-link" href="/refund">Возврат средств</a></li>
            </ul>
          </div>

          <div className="footer-links">
            <h4 className="footer-title">Информация</h4>
            <ul className="footer-list">
              <li><a className="footer-link" href="/system-requirements">Системные требования</a></li>
              <li><a className="footer-link" href="/faq">FAQ</a></li>
              <li><a className="footer-link" href="/security">Политика безопасности</a></li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Комбинат Цифровых Решений. Все права защищены.</p>
        </div>
      </div>
    </footer>
  );
}

